export default {
  handler: 'showRightSidebarComponent',
  data: () => 'betslip',
};
